var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#fff","padding":"15px 0","word-wrap":"break-word"}},[_c('div',{staticStyle:{"width":"70%","margin-left":"15%","padding":"15px","border":"1px solid #e6e6e6","box-sizing":"border-box"},domProps:{"innerHTML":_vm._s(_vm.info.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }